import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { fetchAllUsersList } from "../../store/usersList";

import { Checkbox, TextBox, InputSuffix, InputSeparator } from "@progress/kendo-react-inputs";
import "./dialog.css";
import { Icon } from "@progress/kendo-react-common";
import SearchIcon from "../../assets/communication/search_icon.svg";

export const UserListDialog = (props) => {
  const dispatch = useDispatch();
  const [selectedUsers, setSelectedUsers] = useState(props.defaultSelected);
  const { users_list } = useSelector((state) => state?.usersList);

  const [searchValue, setSearchValue] = useState("");
  const [filteredGroupUsers, setFilteredGroupUsers] = useState([]);
  let delay;
  useEffect(() => {
    dispatch(fetchAllUsersList());
  }, [])
  useEffect(() => {
    if (users_list.length > 0) {
      setFilteredGroupUsers(users_list);
    }
  }, [users_list]);
  const handleSelected = (e, val) => {
    let updatedList = [...selectedUsers];
    if (e.target.value) {
      updatedList = [...selectedUsers, val];
    } else {
      const selected_index = selectedUsers.map((v) => v.username).indexOf(val.username)
      updatedList.splice(selected_index, 1);
    }
    setSelectedUsers(updatedList);
  }
  const handleSubmitDepots = () => {
    props.callback(selectedUsers);
  }
  const filterGroupUsers = () => {
    console.log("filterGroupUsers: ", searchValue);
    console.log();
    if (searchValue === "") {
      setFilteredGroupUsers(users_list);
    } else {
      const groups = users_list.filter(
        (x) =>
          (x.username !== null &&
            x.username.includes(searchValue.toLowerCase())) ||
          (x.name !== null &&
            x.name.toLowerCase().includes(searchValue.toLowerCase()))
      );
      console.log("filterGroupUsers groups:", groups);
      setFilteredGroupUsers(groups);
    }
  };
  useEffect(() => {
    delay = setTimeout(() => {
      if (
        (searchValue.length >= 3 || searchValue.length === 0) &&
        users_list.length > 0
      )
        filterGroupUsers();
    }, 1000);

    return () => clearTimeout(delay);
  }, [searchValue]);

  const handleSearchTextChanged = React.useCallback((event) => {
    setSearchValue(event.target.value);
    console.log("handleChange: ", event.target.value);
  }, []);
  const isChecked = (item) =>
    selectedUsers.map((v) => v.username).includes(item) ? true : false;
  return (
    <Dialog
      title={`Please select user(s): ${selectedUsers?.length} selected`}
      width={500}
      height={500}
      onClose={props.onClickNo}
      className="depot-dialog"
    >
      <div className="depot-list-div">
        <TextBox
          className="group-user-search-box-txtbox"
          value={searchValue}
          onChange={handleSearchTextChanged}
          placeholder="Search by Username / Name (min 3 characters)"
          suffix={() => (
            <>
              <InputSuffix>
                <Icon>
                  <img src={SearchIcon} />
                  &nbsp;
                </Icon>
              </InputSuffix>
              <InputSeparator />
            </>
          )}
        />
        {filteredGroupUsers.filter((x) => x.is_active == true).map((v) => (
          <Checkbox label={`${v.name} (${v.username})`} onChange={(e) => handleSelected(e, v)} checked={isChecked(v.username)} />
        ))}
      </div>
      <DialogActionsBar>
        <button
          className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base depot-cancel-button"
          onClick={props.onClickNo}
        >
          No
        </button>
        <button
          className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base depot-submit-button"
          onClick={handleSubmitDepots}
        >
          Yes
        </button>
      </DialogActionsBar>
    </Dialog>
  );
};